import { ConnectionManagerNetworkKeys } from '../helpers/constants';

function getIcon(customFields) {
  const iconObject = customFields?.find(({ key }) => key === 'icon');
  return iconObject?.value;
}

function getVendor(customFields) {
  const vendorObject = customFields?.find(({ key }) => key === 'vendor');
  return vendorObject?.value;
}

function isInstanceReady(customFields) {
  const isReadyObject = customFields?.find(({ key }) => key === 'isready');
  return isReadyObject?.value === 'true';
}

export default function availableTrayWorkflow(rawWorkflow) {
  const workflowNode = rawWorkflow.node;

  return {
    id: workflowNode.id,
    title: workflowNode.title,
    description: workflowNode.description,
    logo: getIcon(workflowNode.customFields),
    isReady: isInstanceReady(workflowNode.customFields),
    vendor: getVendor(workflowNode.customFields),
    type: ConnectionManagerNetworkKeys.TRAY,
    isSupported: true,
  };
}
